/* Browup: say where we ship, before the shopper invests effort.

   The store sells to the United States only. Without a notice, a non-US
   visitor browses, picks a shade, adds to cart, and only discovers the
   problem at the payment step as a red error - which is the most expensive
   possible moment to find out. A quiet line under the buy button costs a US
   shopper nothing and saves everyone else the wasted trip. */
(function () {
  'use strict';

  var NOTE_CLASS = 'browup-ship-note';

  function insert() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.querySelector('.' + NOTE_CLASS)) return;

    var button = form.querySelector('[type="submit"]');
    if (!button) return;

    var note = document.createElement('p');
    note.className = NOTE_CLASS;
    note.textContent = 'Ships within the USA \u00b7 5\u201312 business days';
    note.style.cssText = [
      'margin:10px 0 0',
      'text-align:center',
      'font-size:13px',
      'line-height:1.4',
      'opacity:.72',
      'letter-spacing:.01em'
    ].join(';');

    var anchor = button.closest('.product-form__buttons') || button;
    if (anchor.parentNode) anchor.parentNode.insertBefore(note, anchor.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', insert);
  else insert();
  document.addEventListener('shopify:section:load', insert);
})();
